export const appVersion = __APP_VERSION__;
export const buildCommit = __GIT_COMMIT__;
export const buildBranch = __GIT_BRANCH__;
export const buildDate = __BUILD_DATE__;

export const repositoryUrl = "https://github.com/baditaflorin/group-theory-visualizer";
export const paypalUrl = "https://www.paypal.com/paypalme/florinbadita";
export const liveUrl = "https://baditaflorin.github.io/group-theory-visualizer/";
